import { Breadcrumb, ButtonGroup, TitleScreen } from "components/Core"
import { FormPresaleItem } from "components/FormEntities"
import useForm from "hooks/useForm"
import { presale_item_values } from "utils/forms_default/item_values"
import { schemaValidationPresaleItems } from "utils/yup/items_schema"
import { parsed_body_to_send } from "components/FormEntities/FormPresaleItem/presale_item.config"
import useItemsResources from "hooks/entities/useItemsResources"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"

const NewScreen = () => {
  const navigate = useNavigate()

  const { control, errors, handleSubmit, watch, setValue, register } = useForm({
    defaultValues: presale_item_values,
    schema: schemaValidationPresaleItems,
  })
  const { set_loading_app, put_load_items_action } = useItemsResources()

  const on_submit = async (data: any) => {
    try {
      set_loading_app(true)
      const body = parsed_body_to_send(data)
      let res: any = await put_load_items_action({ body })
      if (res?.data?.code === 200) {
        Swal.fire({
          title: "Hecho",
          text: "Preventa hecha",
          icon: "success",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#002EFE",
        })
        navigate(`/presale/items`)
      }
      set_loading_app(false)
    } catch (error: any) {
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      set_loading_app(false)
    }
  }
  console.log("errors", errors)

  return (
    <div className="w-full h-full flex flex-col items-start justify-start">
      <Breadcrumb
        data={[
          { name: "Listado de artículos preventa", href: "/presale/items" },
          { name: "Creación de preventa", href: "/presale/items/new" },
        ]}
      />
      <div className="w-full flex flex-col justify-center items-center py-4 px-6">
        <TitleScreen title="creación de preventa" />
        {/* <p>ItemNewScreen</p> */}
      </div>
      <form className="w-full flex flex-col py-2 px-4 lg:px-10" onSubmit={handleSubmit(on_submit)}>
        <div className="w-full flex flex-row items-center justify-end lg:pb-10 py-2">
          <ButtonGroup />
        </div>
        <FormPresaleItem control={control} errors={errors} watch={watch} setValue={setValue} register={register} />
      </form>
    </div>
  )
}

export default NewScreen
